<template>
    <v-layout row wrap>
        <v-flex xs4 pl-2>
            <v-select
                solo
                label="00"
                data-qe-id="time-picker_hour"
                v-model="selectedHours"
                :items="hours">
            </v-select>
        </v-flex>
        <v-flex xs4 pl-2>
            <v-select
                solo
                label="00"
                data-qe-id="time-picker_minute"
                v-model="selectedMinutes"
                :items="minutes">
            </v-select>
        </v-flex>
        <v-flex xs4 pl-2>
            <v-select
                solo
                label="AM"
                data-qe-id="time-picker_am-pm"
                v-model="selectedAMPM"
                :items="ampm">
            </v-select>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: 'time-picker',
        props: {
            value: {
                type: Object,
                default: () => ({ hours: null, minutes: null, ampm: null }),
            },

        },
        data: () => {
            return {
                hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
                minutes: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13'],
                ampm: ['AM', 'PM'],
            };
        },
        computed: {
            selectedHours: {
                get() {
                    if (this.value && this.value.hours) {
                        return this.value.hours;
                    }
                    return null;
                },
                set(val) {
                    this.$emit("input", { hours: val, minutes: this.value.minutes, ampm: this.value.ampm });
                },
            },
            selectedMinutes: {
                get() {
                    if (this.value && this.value.minutes) {
                        return this.value.minutes;
                    }
                    return null;
                },
                set(val) {
                    this.$emit("input", { hours: this.value.hours, minutes: val, ampm: this.value.ampm });
                },
            },
            selectedAMPM: {
                get() {
                    if (this.value && this.value.ampm) {
                        return this.value.ampm;
                    }
                    return null;
                },
                set(val) {
                    this.$emit("input", { hours: this.value.hours, minutes: this.value.minutes, ampm: val });
                },
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .time-picker {}
</style>
